export default {
    methods: {
        catchAndExecute (err, callback) {
            if (err instanceof Error) { throw err }
            return callback(err)
        },
        catchAndLog (err) {
            if (err instanceof Error) { throw err }
            console.log(err)
            return err
        },
        catchAndNotify (err) {
            if (err instanceof Error) { throw err }
            if ((Array.isArray(err) && err.length && Object.keys(err)[0])) {
                let keys = Object.keys(err[0])
                let message = ""
                if (keys.length === 1 && keys[0].startsWith('PROMO_CODE')) {
                    message = Object.values(err[0])[0].message
                } else {
                    message = err[0].message
                }
                this.$notify({
                    text: message,
                    title: 'Uh oh! Something went wrong.',
                    type: 'error'
                })
            } else {
                this.$notify({
                    text: (Array.isArray(err) && err.length) ? err[0].message : err || 'An unknown error occurred.',
                    title: 'Uh oh! Something went wrong.',
                    type: 'error'
                })
            }
            return err
        }
    }
}
